import { FaFacebookF, FaTwitter, FaInstagram, FaArrowUp } from "react-icons/fa";
import { MdEmail, MdPhone } from "react-icons/md";
import { motion } from "framer-motion";
import { BiRightArrow } from "react-icons/bi";
import { TiLocationArrowOutline } from "react-icons/ti";
import { useNavigate } from "react-router-dom";

const socialIcons = [
  { icon: <FaFacebookF />, color: "bg-blue-600 hover:bg-blue-700" },
  { icon: <FaTwitter />, color: "bg-sky-400 hover:bg-sky-500" },
  { icon: <FaInstagram />, color: "bg-pink-500 hover:bg-pink-600" },
];

const links = [
  { label: "Home", id: "home" },
  { label: "Services", id: "services" },
  { label: "About Us", id: "about_us" },
  { label: "Contact", id: "contact" },
];

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="bg-gradient-to-r from-[#020046] to-[#0a0477] text-white py-12 px-6 lg:px-20 relative">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="flex flex-col gap-4"
        >
          <div className="text-2xl font-bold flex items-center gap-2">
            <img src="/logo.png" alt="Glow PCOD" className="w-10 h-10" />
            Glow PCOD
          </div>
          <p className="text-sm text-gray-300">
            Best PCOD & Women’s Health Clinic in Lucknow
          </p>
          <div className="flex gap-3 mt-2">
            {socialIcons.map((item, idx) => (
              <motion.div
                key={idx}
                whileHover={{ scale: 1.2 }}
                className={`w-8 h-8 flex items-center justify-center rounded-full text-white cursor-pointer ${item.color} transition-colors duration-300`}
              >
                {item.icon}
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="flex flex-col gap-3"
        >
          <h3 className="text-lg font-semibold border-b border-gray-500 pb-2">
            Explore
          </h3>
          <ul className="flex flex-col gap-2 mt-2 text-gray-300">
            {links.map(({ label, id }) => (
              <motion.li
                key={id}
                whileHover={{ x: 5, opacity: 0.8 }}
                onClick={() => {
                  navigate(`/${id}`);
                }}
                className="flex items-center gap-2 cursor-pointer transition-all duration-300"
              >
                <span className="text-sm text-pink-400">
                  <BiRightArrow />
                </span>{" "}
                {label}
              </motion.li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="flex flex-col gap-3"
        >
          <h3 className="text-lg font-semibold border-b border-gray-500 pb-2">
            Contact Info
          </h3>
          <div className="flex flex-col gap-2 mt-2 text-gray-300 text-sm">
            <p className="flex items-center gap-2">
              <MdPhone className="text-pink-400" size={20} /> +91-9859238743
            </p>
            <p className="flex items-center gap-2">
              <MdEmail className="text-pink-400" size={20} /> info@glowpcod.in
            </p>
            <p className="flex items-start gap-2">
              <TiLocationArrowOutline className="text-pink-400" size={25} />
              glowpcod, Hasanganj, Lucknow, Uttar Pradesh 226007
            </p>
          </div>
        </motion.div>
      </div>
      <div className="absolute bottom-6 right-6">
        <button
          onClick={() =>
            document
              .getElementById("home")
              ?.scrollIntoView({ behavior: "smooth" })
          }
          className="group relative inline-flex h-11 w-11 items-center justify-center overflow-hidden rounded-full bg-black font-medium text-neutral-200 cursor-pointer"
        >
          <div className="translate-y-0 transition group-hover:translate-y-[300%]">
            <FaArrowUp size={16} />
          </div>
          <div className="absolute -translate-y-[300%] transition group-hover:translate-y-0">
            <FaArrowUp size={16} />
          </div>
        </button>
      </div>
    </footer>
  );
};

export default Footer;
